import axios from "axios";

const env = "dev"; //staging dev prod
//techovaruas-backend-6pws.vercel.app
// export const baseUrl = env === "prod" ? `http://localhost:5001/api` : `https://techovaruas-backend.vercel.app/api`;
// export const baseUrl = `http://localhost:5001/api`;
export const baseUrl = process.env.REACT_APP_BASE_URL;
// export const firebaseHost = "http://127.0.0.1:5001/tehogolf/europe-west2"
// export const firebaseHost = "http://127.0.0.1:5001/sgs-golf-dev/europe-west2"
export const firebaseHost = process.env.REACT_APP_FUNCTIONS_URL;
// export const firebaseHost = "https://europe-west2-tehogolf.cloudfunctions.net"
const requestHeader = {
    // Accept: "*/*",
    "Content-Type": "application/json",
};

export const httpClient = axios.create({
    baseURL: baseUrl, //YOUR_API_URL HERE
    headers: requestHeader,
    // withCredentials:true
});

export const httpsFunctions = axios.create({
    baseURL: firebaseHost, //YOUR_API_URL HERE
    headers: requestHeader,
});
